<app-page-header [heading]="'Pricing List'" [icon]="'fa-list'" style="height:100px;"></app-page-header>
<div class="page-panel">
  <div class=" row">
    <div class="col-lg-8"></div>
    <div class="col-lg-4 mb-3">
      <div style="float: right">
        <a class="btn  btn-success btn-sm ng-star-inserted" routerLink="/pricing-list/add-price"
           title="Create price">&nbsp;<i
          class="fa fa-plus text-white"></i>&nbsp;</a>&nbsp;&nbsp;
      </div>
    </div>
  </div>

  <div>
    <table class="table tbl  table-bordered">
      <tbody>
      <tr *ngIf="(combo_datas | json) == '[]'">
        <td class="text-center" colspan="10">No data to list</td>
      </tr>
      <ng-container *ngFor="let items of combo_datas;let i=index">
        <tr style="font-weight: bolder;background-color: rgb(9, 170, 157);color: white;">
          <th class="text-center" width="2%"><label>{{ i + 1 }}</label></th>
          <th colspan="2"> {{ items.CUSTOMER_ID }}
            <label class="pull-right">
              {{ utils.date(items.DATE) }}
            </label>
          </th>
          <th class="text-center" width="10%">
            <button (click)="print(items);open(content);" alt="View" class="btn btn-xs btn-margin btn-info"
                    style="font-size: 12px;background-color: white;" title="View"><i
              class="text-primary fa fa-eye"></i></button>&nbsp;&nbsp;
            <button (click)="delete(items)" alt="Delete" class="btn btn-xs"
                    style="font-size: 12px;background-color: white;"
                    title="Delete"><i class="text-danger fa fa-trash"></i></button>

          </th>
        </tr>
        <tr class="text-center" style="background-color:rgb(233, 236, 238);font-weight: bolder;">
          <td class="text-center" width="1%">Sl</td>
          <td class="text-center">Particular</td>
          <td class="text-center" width="10%">Price</td>
          <td class="text-center" width="10%">MRP</td>
        </tr>
        <tr *ngFor="let item of items.ITEMS;let i=index">
          <td class="text-center">{{ 1 + i }}</td>
          <td> {{ item.TRADE_NAME }}</td>
          <td class="text-right">{{ item.PRICE }}</td>
          <td class="text-right">{{ item.MRP }}</td>
        </tr>

      </ng-container>
      </tbody>
    </table>
    <div class="clearfix"></div>
    <div class="clearfix"></div>
  </div>
</div>


<ng-template #content let-modal>
  <div class="modal-header">
    <div class="d-flex justify-content-between align-items-center w-100">
      <h4 id="modal-basic-title">
        Pricing List
      </h4>

      <div class="d-flex justify-content-end">
        <button class="btn  btn-info btn-sm ng-star-inserted" ngxPrint
                printSectionId="printList" title="Print">
          <i class=" fa fa-print">&nbsp;&nbsp;</i>&nbsp;&nbsp;Print
        </button>
      </div>
    </div>

    <button (click)="modal.dismiss('Cross click')" aria-label="Close" class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="a4-page" style="display: block">
      <div id="printList">
        <div
          style="font-size: 12px; font-family: 'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';">
          <!--Header-->
          <div style="display:grid;grid-template-columns: 58% 42%;">
            <div style="align-items: center;justify-content: flex-start;display: flex;">
              <ng-container *ngIf="institution.INSTITUTION_LOGO">
                <img alt="" height="60" ngSrc="{{logo_path+institution.INSTITUTION_LOGO}}" style="object-fit: contain;display: block;margin-left: 0;width: auto"
                     width="60">
              </ng-container>
            </div>
            <div>
              <ng-container *ngIf="institution">
                <h5 style="font-size: 16px;font-weight: bold;margin: 0">{{ institution.INSTITUTION_NAME }}</h5>
                <div style="font-size: 12px;line-height: 20px;margin-top: 15px">{{ institution.INSTITUTION_ADDRESS }}
                  <br/>
                  {{ institution.INSTITUTION_CITY }},&nbsp;{{ institution.INSTITUTION_COUNTRY_NAME }} <br/>
                  Ph:&nbsp;{{ institution.INSTITUTION_PHONE_NO }}<br/>
                  Email :&nbsp;{{ institution.INSTITUTION_EMAIL }}<br/>
                  VAT IN&nbsp;&nbsp;:&nbsp;&nbsp;{{ institution.INSTITUTION_VAT_NO }}
                </div>
              </ng-container>
            </div>
          </div>
          <!-- invoice heading-->
          <div style="font-size: 22px;font-weight: bold;padding: 15px;text-align: center;width: 100%">PRICE LIST</div>

          <!--invoice and customer details-->
          <div style="display:grid;grid-template-columns: 58% 42%;">
            <!--customer details-->
            <div style="padding-right: 45px;">
              <div *ngIf="customer" style="display: grid;grid-template-columns:25% 3% 72%;align-items: flex-start;">
                <p style="margin: 0;font-size: 14px;">Customer</p>
                <span>:&nbsp;</span>
                <p style="margin: 0;font-size: 14px;">{{ customer }}</p>
              </div>
            </div>

            <!--details-->
            <div>
              <div *ngIf="date" style="display: grid;grid-template-columns:25% 3% 72%;align-items: flex-start;">
                <p style="margin: 0;font-size: 14px;">Date</p>
                <span>:&nbsp;</span>
                <p style="margin: 0;font-size: 14px;">{{ date }}</p>
              </div>
            </div>
          </div>
          <div>
            <!--particulars-->
            <table
              style="width: 100%;border: 1px solid black;margin-top: 40px;border-collapse: collapse;border-radius: 0;">
              <thead>
              <tr style="border: 1px solid  #dee2e6;">
                <th
                  style="font-weight: bold;color: #000000 !important;background: white !important;padding: 5px !important;font-size: 14px !important;border:1px solid black;text-align: left;width:3%;">
                  #
                </th>
                <th
                  style="font-weight: bold;color: #000000 !important;background: white !important;padding: 5px !important;font-size: 14px !important;border:1px solid black;text-align: left;">
                  Item
                </th>
                <th
                  style="font-weight: bold;color: #000000 !important;background: white !important;padding: 5px !important;font-size: 14px !important;border:1px solid black;text-align: right;width:10%;">
                  Price
                </th>
                <th
                  style="font-weight: bold;color: #000000 !important;background: white !important;padding: 5px !important;font-size: 14px !important;border:1px solid black;text-align: right;width:10%;">
                  MRP
                </th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let item of print_data;let i=index" style="border: 1px solid  #dee2e6; ">
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;">{{ i + 1 }}
                </td>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;"> {{ item.TRADE_NAME }}
                </td>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: right;">{{ item.PRICE }}
                </td>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: right;">{{ item.MRP }}
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div
            style="font-size: 12px;padding-right: 55px;margin-top:15px;text-align: right;width: 100%;font-weight:bold;font-style: italic">
            Price Including VAT
          </div>
          <div style="font-size: 16px;padding-top:  15px;text-align: left;width: 100%;font-weight:bold;">For order
            contact :
            +91 96050 33 666, 96050 22 666, 0471 2593 121
          </div>

          <div style="font-size: 12px;padding-top: 15px;text-align: left;width: 100%;">Payment Options&nbsp;:</div>
          <div>
            <table
              style="width: 70%;border: 1px solid black;border-collapse: collapse;border-radius: 0;margin-top: 5px;">
              <thead>
              <tbody>
              <tr>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;">1
                </td>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;">
                  Cash on delivery
                </td>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;">
                  Available
                </td>
              </tr>

              <tr>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;">2
                </td>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;">
                  Cheque
                </td>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;">
                  In favour of <br> WIKTA IT SERVICES
                </td>
              </tr>


              <tr>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;">3
                </td>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;">
                  Online Transfer
                </td>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;">
                  WIKTA IT SERVICES<br>
                  Bank : State Bank of India <br>
                  Account Number : xxxxxxxx <br>
                  IFSC : SBIN0017183 <br></td>
              </tr>

              <tr>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;">4
                </td>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;">
                  Unified Payments Interface
                </td>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;">
                  UPI ID : wiktait&#64;sbi
                </td>
              </tr>

              <tr>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;">5
                </td>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;">
                  POS Swiping
                </td>
                <td
                  style="padding: 5px !important;font-size: 12px !important;border:1px solid black;text-align: left;">
                  Available on request
                </td>
              </tr>

              </tbody>
            </table>
          </div>
          <!-- footer-->
          <div
            style="font-size: 12px;padding: 15px;text-align: center;width: 100%;position: absolute;bottom: 15px;left: 0;right: 0;">
            This is a computer-generated
            document.
            No signature is required.
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
